import { render, staticRenderFns } from "./DuplicateProjectModal.vue?vue&type=template&id=af9c15bc&"
import script from "./DuplicateProjectModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateProjectModal.vue?vue&type=style&index=0&scooped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports